import apiClient from './apiClient';

export const studyApi = {
  async setStatus(classId: string, looking: boolean) {
    const { data } = await apiClient.post('/api/study/groups/status', { class_id: classId, looking });
    return data as { status: string; looking: boolean };
  },
  async getStatus(classId: string) {
    const { data } = await apiClient.get('/api/study/groups/status', { params: { class_id: classId } });
    return data as { looking: boolean };
  },
  async listGroups() {
    const { data } = await apiClient.get('/api/study/groups');
    return data as { groups: Array<{ class: { id: string; name: string }, students: Array<{ id: string; first_name: string; last_name: string }> }> };
  },
};


